import styled from 'styled-components'

export const ClearButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: ${props => props.theme.spacing.sp4};
`
